import React, { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const GalleryM = () => {
  const images = [
    //1//
    {
      src: "/img/mariage/1/y8zk9qjvlmdudct0skvs_compression.jpg",
      alt: "Photo 1",
      category: "Portrait",
    },
    {
      src: "/img/mariage/1/monj1qtvruvnolktc8dg_compression.jpg",
      alt: "Photo 2",
      category: "Portrait",
    },
    {
      src: "/img/mariage/1/qqcfwqy1xc9mumoy5j56_compression.jpg",
      alt: "Photo 3",
      category: "Portrait",
    },
    //2//
    {
      src: "/img/portfolio/RECADRAGE/fzme5lvshspd7kkgxuzx_compression.jpg",
      alt: "Photo 4",
      category: "Portrait",
    },
    {
      src: "/img/mariage/2/tsgot6sggm7ecd5rphkb_compression.jpg",
      alt: "Photo 5",
      category: "Portrait",
    },
    {
      src: "/img/mariage/2/cs5zbwnr3tn5cqsz6grz_compression.jpg",
      alt: "Photo 6",
      category: "Portrait",
    },
    //3//
    {
      src: "/img/mariage/3/qewurbfwkkkmq22omv5w_compression.jpg",
      alt: "Photo 7",
      category: "Portrait",
    },
    {
      src: "/img/mariage/3/hw2hefcmujqspaftt3zf_compression.jpg",
      alt: "Photo 8",
      category: "Portrait",
    },
    {
      src: "/img/mariage/3/gbcntlkz5wjdkqgxki8l_compression.jpg",
      alt: "Photo 9",
      category: "Portrait",
    },
    //4//
    {
      src: "/img/mariage/4/sjuamkh310hunk6vdltq_compression.jpg",
      alt: "Photo 10",
      category: "Portrait",
    },
    {
      src: "/img/mariage/4/jsfy9covwci0kgqjwz0j_compression.jpg",
      alt: "Photo 11",
      category: "Portrait",
    },
    {
      src: "/img/mariage/4/decdav6lbl1za0p8rmxv_compression.jpg",
      alt: "Photo 12",
      category: "Portrait",
    },
    //5//
    {
      src: "/img/mariage/5/ubcsnervaxvuwyyay52p_compression.jpg",
      alt: "Photo 13",
      category: "Portrait",
    },
    {
      src: "/img/mariage/5/tazxjk4pjnwziglrc9h4_compression.jpg",
      alt: "Photo 14",
      category: "Portrait",
    },
    {
      src: "/img/mariage/5/mu2t4hcgv68ah7b9vws5_compression.jpg",
      alt: "Photo 15",
      category: "Portrait",
    },
    //6//
    {
      src: "/img/mariage/6/pprlc4qvrs94facrfzgd_compression.jpg",
      alt: "Photo 16",
      category: "Portrait",
    },
    {
      src: "/img/mariage/6/wbkynqvijqh0ilv4gtor_compression.jpg",
      alt: "Photo 17",
      category: "Portrait",
    },
    {
      src: "/img/mariage/6/jsmic3fpbrxr6xuu8u3h_compression.jpg",
      alt: "Photo 18",
      category: "Portrait",
    },
    //7//

    {
      src: "/img/portfolio/atdk0sd5sp9dumwifmfi_compression.jpg",
      alt: "Photo 19",
      category: "Portrait",
    },
    {
      src: "/img/mariage/7/km3xmtz8bvziemyw0elu_compression.jpg",
      alt: "Photo 20",
      category: "Portrait",
    },

    {
      src: "/img/mariage/7/horrhzewpfe3woljcccu_compression.jpg",
      alt: "Photo 21",
      category: "Portrait",
    },
    //8//

    {
      src: "/img/mariage/8/vd2pr53ptpfyvko7hnea_compression.jpg",
      alt: "Photo 22",
      category: "Portrait",
    },
    {
      src: "/img/mariage/8/datqqnxdmzeexitlu9an_compression.jpg",
      alt: "Photo 23",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/kyrtbg1re9eoecm6dsno_compression.jpg",
      alt: "Photo 24",
      category: "Portrait",
    },
    //10//
    {
      src: "/img/mariage/9/xoopxtioxca45ba5kchz_compression.jpg",
      alt: "Photo 25",
      category: "Portrait",
    },

    {
      src: "/img/mariage/9/mu038lfbabk7wnzl16q9_compression.jpg",
      alt: "Photo 26",
      category: "Portrait",
    },
    {
      src: "/img/mariage/9/ifitrkxc10kw9wakt4id_compression.jpg",
      alt: "Photo 27",
      category: "Portrait",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <>
      <style>
        {`
    .lb-canvas .lb-img {
      max-height: 100%;
    }
    .lb-img {
      width: auto;
    }
  `}
      </style>
      {/* Section Header */}
      <section
        className="banner-header banner-img banner-img-top section-padding valign bg-img bg-fixed banner-overlay"
        data-overlay-darkgray="1"
        style={{
          backgroundImage:
            "url('/img/mariage/4/sjuamkh310hunk6vdltq_compression.jpg')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <h1>Mariage</h1>
              <hr className="border-1 text-white" />
              <p>
                Laissez-nous raconter votre mariage à travers des photographies
                authentiques. Découvrez nos réalisations et offrez-vous des
                images à la hauteur de ce jour unique.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Portfolio */}
      <section className="projects2 section-padding bg-blck">
        <div className="container">
          <div className="row">
            {images.map((image, index) => (
              <div
                key={index}
                className="col-12 col-md-4 portfolio-masonry-wrapper-padding"
              >
                <div className="portfolio-item-wrapp">
                  <div
                    className="portfolio-item"
                    onClick={() => {
                      setPhotoIndex(index);
                      setIsOpen(true);
                    }}
                  >
                    <div className="portfolio-masonry-wrapper">
                      <img
                        src={image.src}
                        className="img-fluid mx-auto d-block"
                        alt={image.alt}
                      />
                      <div className="portfolio-masonry-item-content">
                        <div className="portfolio-masonry-item-category">
                          {image.category}
                        </div>
                        <h4 className="portfolio-masonry-item-title">
                          {image.title}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {isOpen && (
          <Lightbox
            images={images.map((img) => ({ url: img.src, title: img.title }))}
            startIndex={photoIndex}
            onClose={() => setIsOpen(false)}
          />
        )}
      </section>
    </>
  );
};

export default GalleryM;
